import { ApplicationConfig, ErrorHandler, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import * as Sentry from '@sentry/angular';
import { jwtInterceptor } from './core/interceptors/jwt.interceptor';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { provideMonacoEditor } from 'ngx-monaco-editor-v2';
import { ConfirmationService, MessageService } from 'primeng/api';
import Aura from '@primeuix/themes/nora';
import { routes } from './app.routes';
import { environment } from '../environments/environment';

export const appConfig: ApplicationConfig = {
	providers: [
		provideZonelessChangeDetection(),
		// Reports uncaught component/template errors to Sentry; no-ops when
		// Sentry.init() wasn't called in main.ts (no DSN configured).
		{ provide: ErrorHandler, useValue: Sentry.createErrorHandler() },
		provideRouter(routes),
		provideHttpClient(withFetch(), withInterceptors([jwtInterceptor])),
		provideAnimationsAsync(),
		providePrimeNG({
			theme: {
				preset: Aura,
				options: {
					darkModeSelector: '.app-dark',
				},
			},
			license: environment.primeuiLicenseKey,
		}),
		provideMonacoEditor(),
		// Root-scoped MessageService so root-scoped services (UploadService) can
		// post toasts. The editor component provides its own instance for its
		// own scope — those stay local to the editor's <p-toast />.
		MessageService,
		// Root-scoped ConfirmationService routes confirmations to the single
		// <p-confirmDialog /> mounted in app.html.
		ConfirmationService,
	],
};
